// extracted by mini-css-extract-plugin
export default {"body":"kyc_aml_policy_body__VrEZv","head_pare":"kyc_aml_policy_head_pare__ROITJ"};